﻿import type { ReservationState } from './types';
import type { ProgramBookingState } from './model.Programs';

import { useModelState } from '@/utils/useModelState';

import { Oval } from 'react-loader-spinner'

import { default as classNames } from "classnames";

import { useEffect, useState, type ReactNode } from 'react';

import { ProgramPriceDialogComponent } from './ProgramPriceDialogComponent';
import { countCalendarDaysBetween } from '@/utils/utils';


export function ProgramPriceComponent({ reservationState, programBookingState }: ProgramPriceComponentProps) {

    const [price] = useModelState(programBookingState.CalculatedPrice);
    const [isLoading] = useModelState(programBookingState.Price.isLoading);

    const discounted = price.totalBaseAmount > price.totalPayableAmount;

    const [dialogVisible, setDialogVisible] = useState(false);

    const [startDate] = useModelState(programBookingState.Start);
    const [endDate] = useModelState(programBookingState.End);

    const days = countCalendarDaysBetween(startDate, endDate);

    const daysText = days === 1 ? 'Day' : 'Days';

    return (
        <div className="flex gap-0.5" >
            <div className="flex cursor-pointer gap-2" onClick={() => {
                setDialogVisible(true);
            }}>
                <div>
                    {days} {daysText} -
                </div>
                <div className={classNames({ 'line-through': discounted })}>
                    {price.totalBaseAmount.toLocaleString('en-NZ', { style: 'currency', currency: 'THB' })}
                </div>
                {discounted && (
                    <div>
                        {price.totalPayableAmount.toLocaleString('en-NZ', { style: 'currency', currency: 'THB' })}
                    </div>
                )}
            </div>
            <div>
                {isLoading ?
                    <div>
                        <Oval
                            visible={true}
                            height="20"
                            width="20"
                            ariaLabel="oval-loading"
                            color="#000000"
                            secondaryColor="#000000"
                        />
                    </div> : null}
            </div>
            <ProgramPriceDialogComponent
                reservationState={reservationState}
                programBookingState={programBookingState}
                visible={dialogVisible}
                closed={() => {
                    setDialogVisible(false);
                }} />
        </div>
    );
}

export interface ProgramPriceComponentProps {
    reservationState: ReservationState;
    programBookingState: ProgramBookingState;
}
